<div class="container my-5 mx-auto">
  <div class="justify-content-center modal-dialog-centered">
      <div class="col-sm-12 col-md-12 col-lg-12 shadow-lg p-3 fondo rounded text-center">
          <div id="accordion" role="tablist">
              <div class="card mt-2">
                  <div id="infoGeneral" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloGeneral">
                      <form [formGroup]="forma" (ngSubmit)="completarRegistro()">
                          <label class="col-form-label col-form-label-sm font-weight-bold">Datos de usuario</label>
                          <div class="form-group">
                              <input
                              class="form-control"
                              type="email"
                              placeholder="Correo Electrónico"
                              formControlName="email">
                          </div>
                          <div class="form-group" [ngClass]="{ 'text-danger' : getPass.touched && getPass.invalid}">
                              <input
                              class="form-control"
                              type="password"
                              placeholder="Contraseña"
                              formControlName="pass">
                              <div class="text-danger" *ngIf="getPass.touched && getPass.hasError('required')">
                                <span>La contraseña es obligatoria</span>
                              </div>
                              <div class="text-danger" *ngIf="getPass.touched && getPass.hasError('pattern')">
                                <span>La contraseña debe tener al menos 8 caracteres, incluyendo una letra minúscula, una letra mayúscula, un número y un carácter especial.</span>
                              </div>
                          </div>
                          <div class="form-group" [ngClass]="{ 'text-danger' : getPass.touched && getPass.invalid}">
                              <input
                              class="form-control"
                              type="password"
                              placeholder="Confirmar Contraseña"
                              [readOnly]="!getPass.value"
                              name="confirm_pass"
                              formControlName="confirm_pass">
                                  <div class="text-danger" *ngIf="getPass.touched && getPass.errors">
                                      <span>Debe confirmar la contraseña</span>
                                  </div>
                                  <div class="text-danger" *ngIf="getPass.touched && !cp">
                                      <span>Las contraseñas deben ser iguales</span>
                                  </div>
                              </div>
                          <hr>
                          <div class="row">
                            <div class="form-group col-lg-12 justify-content-between">
                              <button type="submit" [disabled]="forma.invalid || !cp" class="btn btn-primary text-uppercase font-weight-bold square">Continuar</button>
                              <button type="button" [disabled]="forma.invalid || !cp" class="btn btn-primary text-uppercase font-weight-bold square" (click)="cerrar()">Cerrar</button>
                          </div>
                        </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
      <p class='color-spinner-text'>Cargando... </p>
  </ngx-spinner> -->
</div>
